<template>
    <div>
        <div class="bg-dark m-b-30">
            <div class="container">
                <div class="row p-b-60 p-t-60">

                    <div class="col-md-6 text-white p-b-30">
                        <div class="media">
                            <div class="avatar avatar mr-3">
                                <div class="avatar-title bg-success rounded-circle mdi mdi-currency-usd  "></div>
                            </div>
                            <div class="media-body">
                                <h3 class="p-t-10">{{ $t('supplier.history.title', [supplier.name]) }} </h3>
                                <p class="opacity-75">
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-5 text-white p-b-30 ml-auto">
                        <div class="rounded text-white bg-white-translucent">
                            <div class="p-all-15">
                                <div class="row text-center">
                                    <div class="col-md-6 my-2 m-md-0">
                                        <div class="text-overline opacity-75">{{ $t('supplier.received') }}</div>
                                        <transition name="slide-fades">
                                            <h4 v-if="animation" class="m-0 text-success">
                                                {{ formatPrice(parseInt(supplier.payments_count)) }}</h4>
                                        </transition>
                                    </div>
                                    <div class="col-md-6 my-2 m-md-0">
                                        <div class="text-overline    opacity-75">{{ $t('supplier.pending') }}</div>
                                        <transition name="slide-fades">
                                            <h5 v-if="animation" class="m-0 text-danger">{{ formatPrice
                                                (supplier.amt_owed) }}</h5>
                                        </transition>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container" v-if="hasBusinessInfo">
            <div class="row">
                <div class="col-md-12">
                    <div class="card m-b-30">
                        <div class="card-header">
                            <h5 class="m-b-0">
                                <i class="mdi mdi-office-building"></i> {{ $t('supplier.label.business_information') }}
                            </h5>
                        </div>
                        <div class="card-body">
                            <el-collapse v-model="businessInfoExpanded">
                                <el-collapse-item :title="$t('supplier.label.business_information')" name="1">
                                    <div class="row">
                                        <div class="col-md-6" v-if="supplier.business_name">
                                            <div class="mb-3">
                                                <strong>{{ $t('supplier.label.business_name') }}:</strong>
                                                <p class="mb-0">{{ supplier.business_name }}</p>
                                            </div>
                                        </div>
                                        <div class="col-md-6" v-if="supplier.business_type">
                                            <div class="mb-3">
                                                <strong>{{ $t('supplier.label.business_type') }}:</strong>
                                                <p class="mb-0">{{ formatBusinessType(supplier.business_type) }}</p>
                                            </div>
                                        </div>
                                        <div class="col-md-6" v-if="supplier.tax_id">
                                            <div class="mb-3">
                                                <strong>{{ $t('supplier.label.tax_id') }}:</strong>
                                                <p class="mb-0">{{ supplier.tax_id }}</p>
                                            </div>
                                        </div>
                                        <div class="col-md-6" v-if="supplier.registration_number">
                                            <div class="mb-3">
                                                <strong>{{ $t('supplier.label.registration_number') }}:</strong>
                                                <p class="mb-0">{{ supplier.registration_number }}</p>
                                            </div>
                                        </div>
                                        <div class="col-md-6" v-if="supplier.website">
                                            <div class="mb-3">
                                                <strong>{{ $t('supplier.label.website') }}:</strong>
                                                <p class="mb-0">
                                                    <a :href="supplier.website" target="_blank" rel="noopener noreferrer" class="text-primary">
                                                        {{ supplier.website }}
                                                    </a>
                                                </p>
                                            </div>
                                        </div>
                                        <div class="col-md-6" v-if="supplier.contact_person">
                                            <div class="mb-3">
                                                <strong>{{ $t('supplier.label.contact_person') }}:</strong>
                                                <p class="mb-0">{{ supplier.contact_person }}</p>
                                            </div>
                                        </div>
                                        <div class="col-md-6" v-if="supplier.alternative_phone">
                                            <div class="mb-3">
                                                <strong>{{ $t('supplier.label.alternative_phone') }}:</strong>
                                                <p class="mb-0">{{ supplier.alternative_phone }}</p>
                                            </div>
                                        </div>
                                        <div class="col-md-12" v-if="supplier.business_address">
                                            <div class="mb-3">
                                                <strong>{{ $t('supplier.label.business_address') }}:</strong>
                                                <p class="mb-0" style="white-space: pre-wrap;">{{ supplier.business_address }}</p>
                                            </div>
                                        </div>
                                        <div class="col-md-12" v-if="supplier.notes">
                                            <div class="mb-3">
                                                <strong>{{ $t('supplier.label.notes') }}:</strong>
                                                <p class="mb-0" style="white-space: pre-wrap;">{{ supplier.notes }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </el-collapse-item>
                            </el-collapse>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-md-9 text-center m-b-30 ml-auto">
                    <div class="text-md-right">
                        <router-link :to="{name: 'supplier-history'}"
                                     class="el-button el-button--success el-button--medium"><i
                                class="mdi mdi-contactless-payment"></i> {{ $t('supplier.button.supplies') }}
                        </router-link>
                        <router-link :to="{name: 'supplier-payments'}"
                                     class="el-button el-button--primary el-button--medium"><i
                                class="mdi mdi-subtitles"></i> {{ $t('supplier.button.payment') }}
                        </router-link>
                        <!--<el-button type="default" size="medium" icon="el-icon-s-finance" @click="cashIn">
                            Cash-in
                        </el-button>-->
                        <router-link :to="{name: 'suppliers'}"
                                     class="el-button el-button--warning el-button--medium"><i
                                class="mdi mdi-format-list-bulleted"></i> {{ $t('supplier.button.all') }}
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <transition name="slide-fade">
            <router-view :supplier="supplier" @refresh-supplier="refreshSupplier"/>
        </transition>
    </div>
</template>

<script>
export default {
  name: 'History',
  data () {
    return {
      supplier: {},
      animation: false,
      businessInfoExpanded: []
    }
  },
  computed: {
    hasBusinessInfo () {
      return this.supplier && (
        this.supplier.business_name ||
        this.supplier.tax_id ||
        this.supplier.registration_number ||
        this.supplier.business_type ||
        this.supplier.website ||
        this.supplier.contact_person ||
        this.supplier.alternative_phone ||
        this.supplier.business_address ||
        this.supplier.notes
      )
    }
  },
  methods: {
    formatBusinessType (type) {
      if (!type) return ''
      const types = {
        individual: 'Individual',
        company: 'Company',
        partnership: 'Partnership',
        sole_proprietorship: 'Sole Proprietorship',
        other: 'Other'
      }
      return types[type] || type.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
    },
    animateAmount () {
      this.animation = false
      setTimeout(() => {
        this.animation = true
      }, 600)
    },
    refreshSupplier () {
      this.$supplierService.findById(this.$route.params.id)
        .then(data => {
          this.animateAmount()
          this.supplier = data
          // Expand business info if it exists
          if (this.hasBusinessInfo) {
            this.businessInfoExpanded = ['1']
          }
        })
    }
  },
  mounted () {
    this.refreshSupplier()
  },
  watch: {
    hasBusinessInfo (value) {
      if (value) {
        this.businessInfoExpanded = ['1']
      }
    }
  }
}
</script>

<style scoped>
    .slide-fades-enter-active {
        transition: all .3s ease;
    }

    .slide-fades-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fades-enter, .slide-fades-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }
</style>
